import { instance } from '../../../../../../services/api';

// EU1832 - TO - 08/09/2022
export default (contactAtLocalGroupLinkFileId: number) => {
    return instance.delete(`api/contactAtLocalGroupLinks/${contactAtLocalGroupLinkFileId}`);
};
